module.exports = function (el) {
  var $el = $('.no-touch').find(el)

  var $link = $(el).find('a')

  $link.on('mouseenter', function () {
    $el.addClass('hovered')
  }).on('mouseleave', function () {
    $el.removeClass('hovered')
  })
}
